import { apiClient } from '@/shared/api/apiClient'
import { USER_SESSION_QUERY_KEY } from '@/shared/hooks/api/auth'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export function useSendEmailVerificationCode() {
  return useMutation({
    mutationFn: async () => {
      const response = await apiClient.post(
        '/v1/user/email-verification/send-code'
      )
      return response.data
    },
  })
}

export function useVerifyEmailWithCode() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (code: string) => {
      const response = await apiClient.post(
        '/v1/user/email-verification/verify-code',
        {
          verificationCode: code,
        }
      )

      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USER_SESSION_QUERY_KEY] })
    },
  })
}

export function useUpdateLanguage() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (language: string) => {
      await apiClient.put('/v1/user/language', { language })
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [USER_SESSION_QUERY_KEY] })
    },
  })
}
